import React, { Component } from 'react';

import { Field, reduxForm } from 'redux-form';

import moment from 'moment';

import { DatePicker } from 'redux-form-material-ui';

import FlatButton from 'material-ui/FlatButton';
import Subheader from 'material-ui/Subheader';

import { getTranslatedString } from 'helpers/i18n';

import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  Legend,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  Text,
  Cell,
  PieChart,
  Pie,
} from 'recharts';

import Collapsible from 'components/shared/Collapsible';
import PollResults from 'components/shared/PollResults';

import { toFriendlyDateString } from 'helpers/Formatter';
import { colors, shadeColor } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as format from 'helpers/Formatter';

import styled from 'styled-components';

const PERCENT_OF_COLOR_SHADE_CHANGE = 0.4;
const BAR_CHART_BAR_WIDTH = 100;
const QUESTION_TYPE_FREE_FORM = 0;
const QUESTION_TYPE_MULTIPLE_CHOICE = 1;
const QUESTION_TYPE_TRUE_FALSE = 2;
const QUESTION_TYPE_RATING = 3;
const SURVEY_TYPE_POLL = 4;
const QUESTION_TYPE_RATING_TEN = 5;

class CustomizedAxisTick extends Component {
  render() {
    return (
      <Text {...this.props} width={75} textAnchor="middle">
        {this.props.payload.value}
      </Text>
    );
  }
}

const StyledToolTipContainer = styled.div`
  background-color: #ffffff;
  line-height: 1;
  padding: 10px 10px 0px;
  border: 1px solid #000000;
`;

const CustomBarChartToolTip = ({ payload, label, active }) => {
  if (active) {
    return (
      <StyledToolTipContainer>
        <p>{label}</p>
        <p>{`${getTranslatedString('landlordPortal.surveys.responseCount')}: ${payload[0]
          .value}`}</p>
      </StyledToolTipContainer>
    );
  }

  return null;
};

const CustomTrueFalseToolTip = ({ payload, active }) => {
  if (active) {
    return (
      <StyledToolTipContainer>
        <p>{`${getTranslatedString(
          `landlordPortal.surveys.trueFalse.toolTip.${payload[0].name.toLowerCase()}`
        )}: ${payload[0].value}`}</p>
      </StyledToolTipContainer>
    );
  }

  return null;
};

const StyledTrueFalseLegendSquareIcon = styled.div`
  height: 15px;
  width: 15px;
  margin-right: 6px;
  background: ${props => props.color};
`;
const StyledTrueFalseLegendLabelContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
`;
const StyledTrueFalseLegendContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const TrueFalseLegend = props => {
  const { payload } = props;

  return (
    <StyledTrueFalseLegendContainer>
      {payload.map((entry, index) => (
        <StyledTrueFalseLegendLabelContainer>
          <StyledTrueFalseLegendSquareIcon color={entry.color} />
          <span key={`item-${index}`}>
            {getTranslatedString(
              `landlordPortal.surveys.trueFalse.toolTip.${entry.value.toLowerCase()}`
            )}
          </span>
        </StyledTrueFalseLegendLabelContainer>
      ))}
    </StyledTrueFalseLegendContainer>
  );
};

class SurveyResults extends Component {
  graphMaxWidth = response => {
    if (response.question_type === QUESTION_TYPE_TRUE_FALSE) {
      return '250px';
    } else if (response.question_type === QUESTION_TYPE_FREE_FORM) {
      return '100%';
    } else if (response.question_type === SURVEY_TYPE_POLL) {
      return '80%';
    } else {
      return `${BAR_CHART_BAR_WIDTH * response.question_responses.length}px`;
    }
  };

  render() {
    const { surveyDetails, surveyResults, handleSubmit, submitting, dirty } = this.props;

    const style = {
      receipt_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
      subheader: {
        lineHeight: 0,
        padding: '20px 0px 15px 0px',
      },
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.surveys.surveyDetails')}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="row" style={{ marginBottom: '0px' }}>
            <div className="col-sm-6" style={{ padding: '0' }}>
              <Subheader inset={false} style={style.subheader}>
                {getTranslatedString('landlordPortal.surveys.surveyTitle')}
              </Subheader>
              <div style={style.subheader_side_padding}>
                <p style={style.lease_term}>{surveyDetails.title}</p>
              </div>
            </div>
            <div className="col-sm-6" style={{ padding: '0' }}>
              <Subheader inset={false} style={style.subheader}>
                {getTranslatedString('landlordPortal.surveys.surveyStartDate')}
              </Subheader>
              <div style={style.subheader_side_padding}>
                <p style={style.lease_term}>{toFriendlyDateString(surveyDetails.start_date)}</p>
              </div>
            </div>
          </div>
          <div className="row" style={{ marginBottom: '0px' }}>
            <div className="col-xs-12" style={{ padding: '0' }}>
              <Subheader inset={false} style={style.subheader}>
                {getTranslatedString('landlordPortal.surveys.surveyDescription')}
              </Subheader>
              <div style={style.subheader_side_padding}>
                <p style={style.lease_term}>{surveyDetails.description}</p>
              </div>
            </div>
          </div>
          <div className="row" style={{ padding: 0 }}>
            <Subheader inset={false} style={style.subheader}>
              {getTranslatedString('landlordPortal.surveys.expirationDate')}
            </Subheader>
            <Field
              name="expiration_date"
              component={DatePicker}
              style={{
                marginTop: '-10px',
                fontSize: '14px',
                width: '100%',
                zIndex: 5000,
              }}
              formatDate={format.reformatDate}
              autoOk={true}
              textFieldStyle={{ width: '100%', fontSize: '14px' }}
              minDate={new Date(moment(new Date()).add(1, 'days'))}
              disableYearSelection={true}
            />
          </div>
          <div className="row" style={{ margin: '10px 0 15px', padding: 0, textAlign: 'center' }}>
            <FlatButton
              type="submit"
              disabled={submitting || !dirty}
              style={{
                color: 'white',
                backgroundColor: submitting || !dirty ? colors.LIGHT_GRAY : AccentColor(),
              }}
            >
              {getTranslatedString('landlordPortal.surveys.update')}
            </FlatButton>
          </div>
        </div>

        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.surveys.surveyResults')}
            </p>
          </div>
        </div>
        {surveyResults.map((response, index) => (
          <div className="row" style={{ textAlign: 'center', marginBottom: '15px' }}>
            <h4 style={{ marginBottom: '15px' }}>
              {' '}
              <b>
                {getTranslatedString('landlordPortal.surveys.question')} {`${index + 1}`}:
              </b>{' '}
              {`${response.question_text}`}
            </h4>
            <div className="row" style={{ maxWidth: this.graphMaxWidth(response), margin: 'auto' }}>
              {response.question_type === QUESTION_TYPE_FREE_FORM && (
                <Collapsible
                  headerWidth={180}
                  header={
                    <button type="button" className="link-button">
                      {getTranslatedString('landlordPortal.surveys.clickToViewResponses')}
                    </button>
                  }
                >
                  {response.question_responses.map((question_response, index) => (
                    <div className="row" style={{ fontSize: '12px' }} key={index}>
                      <h5> "{question_response}" </h5>
                    </div>
                  ))}
                </Collapsible>
              )}
              {(response.question_type === QUESTION_TYPE_MULTIPLE_CHOICE ||
                response.question_type === QUESTION_TYPE_RATING ||
                response.question_type === QUESTION_TYPE_RATING_TEN) && (
                <ResponsiveContainer height={200}>
                  <BarChart data={response.question_responses} barCategoryGap={1}>
                    <XAxis interval={0} dataKey="name" width={75} tick={<CustomizedAxisTick />} />
                    <CartesianGrid stroke="#fff" />
                    <Tooltip content={<CustomBarChartToolTip />} />
                    <Bar dataKey="response_count" fill={AccentColor()}>
                      {response.question_responses.map((entry, index) => {
                        return (
                          <Cell
                            fill={shadeColor(
                              AccentColor(),
                              PERCENT_OF_COLOR_SHADE_CHANGE /
                                response.question_responses.length *
                                index
                            )}
                          />
                        );
                      })}
                      <LabelList dataKey="response_count" style={{ fill: 'white' }} />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              )}
              {response.question_type === SURVEY_TYPE_POLL && (
                <PollResults results={response.question_responses} />
              )}
              {response.question_type === QUESTION_TYPE_TRUE_FALSE && (
                <PieChart width={250} height={250}>
                  <Tooltip content={<CustomTrueFalseToolTip />} />
                  <Legend
                    iconType="square"
                    width={262}
                    verticalAlign="middle"
                    content={<TrueFalseLegend />}
                  />
                  <Pie
                    isAnimationActive={false}
                    data={response.question_responses}
                    dataKey="response_count"
                    label={getTranslatedString('landlordPortal.surveys.responseCount')}
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={100}
                    innerRadius={70}
                    fill={AccentColor()}
                    paddingAngle={1}
                  >
                    <LabelList
                      dataKey="response_count"
                      label={getTranslatedString('landlordPortal.surveys.responseCount')}
                      style={{ fill: 'white' }}
                      position={'inside'}
                    />
                    {response.question_responses.map((entry, index) => {
                      return <Cell fill={shadeColor(AccentColor(), 0.5 * index)} />;
                    })}
                  </Pie>
                </PieChart>
              )}
            </div>
          </div>
        ))}
      </form>
    );
  }
}

SurveyResults = reduxForm({
  form: 'edit_survey_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
})(SurveyResults);

export default SurveyResults;
